


































































































































































































































































































import { Component, Vue , Watch} from "vue-property-decorator";
import requestService from "@/service/requestService";
import Number from "@/shared/filters/Number";
import { Utils } from "@/service/util";
import { OptionData, OptionItem } from "@/model/Option";
import { Getter, Action } from "vuex-class";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { UserService } from "@/service/UserService";
import UserFooter from "@/components/UserFooter.vue";
import { MESSAGE } from "@/model/Message";
import TopBarTitle from "@/components/common/TopBarTitle.vue";
import InputNumber from "@/components/common/input/InputNumber.vue";
@Component({
  filters: {
    Number
  },
  components: {
    ConfirmDialog,
    UserFooter,
    TopBarTitle,
    InputNumber
  }
})
export default class OptionPageNex extends Vue {
  isModeModal: boolean = false;
  isModeQuick: boolean = false;
  excludingFlg: boolean = false;
  excludingTex: string = "";

  isEditPrice: boolean = false;
  isEditPriceNex: boolean = false; // ネクステージ用、未使用
  showAside: boolean = true;
  reqService: requestService;
  couponResult: any = 0;
  subTotalZk: number = 0;
  subTotalZn: number = 0;

  updating: boolean = false;
  loadingText: string = MESSAGE.Loading;

  optionNm: string = "";
  optionZk: number | null = null;
  /** 2023-10-19 invoice [START] */
  optionZn: number | null = null;
  /** 2023-10-19 invoice [END] */
  activeTabName: string = "";
  activeHoshou1Id: number = 0;
  activeHoshou2Id: number = 0;

  $refs!: {
    errorDialog: ConfirmDialog;
    waitmd15Dialog: ConfirmDialog;
    inputKingaku: InputNumber[];
  };

  public utils: Utils = new Utils();

  @Action("setOption", { namespace: "Option" })
  setOption: any;
  @Action("confirm", { namespace: "Option" })
  confirm: any;
  @Action("autoSave", { namespace: "Option" })
  autoSave: any;
  @Action("setError", { namespace: "UserDataState" })
  setError: any;
  @Action("updateSubTotal", { namespace: "Option" })
  updateSubTotal: any;

  @Getter("hasData", { namespace: "Option" })
  hasData: boolean;
  @Getter("currentState", { namespace: "Option" })
  optionData: OptionData;
  @Getter("currentState", { namespace: "Option" })
  optionDataForSave: OptionData;
  @Getter("isConfirm", { namespace: "Option" })
  isConfirm: any;
  @Getter("waitingAutoSave", { namespace: "Option" })
  waitingAutoSave: any;

  @Getter("listRunningKijuns", { namespace: "Option" })
  listRunningKijuns: any;
  @Getter("hoshouPlanKey", { namespace: "Option" })
  hoshouPlanKey: any;

  @Getter("listWarranties", { namespace: "Option" })
  listWarranties: any;
  @Getter("listPeriods", { namespace: "Option" })
  listPeriods: any;
  @Getter("listEtcOptions", { namespace: "Option" })
  listEtcOptions: any;

  @Getter("listTires", { namespace: "Option" })
  listTires: any;




  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;
  @Getter("optionLoading", { namespace: "UserDataState" })
  isLoading: boolean;
  @Getter("optionError", { namespace: "UserDataState" })
  optionError: string;
  @Getter("waitPartsSelect", { namespace: "SubHeader" })
  waitPartsSelect: boolean;

  /** 2023-10-19 invoice [START] */
  @Getter("isExcludingTax", { namespace: "FunctionSetting" })
  isExcludingTax: any;
  @Getter("taxLabel", { namespace: "FunctionSetting" })
  taxLabel: string;
  @Getter("optionLabel", { namespace: "FunctionSetting" })
  optionLabel: string;
  /** 2023-10-19 invoice [END] */
 /** 2024-05-02 nextage [START] */
  @Getter("isNextageCustom", { namespace: "FunctionSetting" })
  isNextageCustom: any;
  /** 2024-05-02 nextage [END] */

  get isError() {
    let ret = false;
    if (this.optionError && this.optionError != "") { ret = true; }
    return ret;
  }

  onCloseError() {
    this.setError({ key: "option", value: "" });
  }



  @Watch("hoshouPlanKey")
  menuReload() {
    if (this.activeTabName == "") {
      this.activeTabName = this.hoshouPlanKey[0].key;
    }
    if (this.activeHoshou1Id == 0) {
      if ( this.optionData && this.optionData.option && this.optionData.option.items) {
        this.optionData.option.items.forEach((sub: any) => {
          if ( sub.warrantyKbn==1 &&(sub.isCheck === 1) ) {
            this.activeHoshou1Id = sub.optionId;
            // this.activeHoshou1Id = sub.kijunCd; // 縦1行を開ける
          }
        });
      }
    }
    if (this.activeHoshou2Id == 0) {
      if ( this.optionData && this.optionData.option && this.optionData.option.items) {
        this.optionData.option.items.forEach((sub: any) => {
          if ( sub.warrantyKbn==2 &&(sub.isCheck === 1) ) {
            this.activeHoshou2Id = sub.optionId;
          }
        });
      }
    }





  }

  created() {
    if (window.sessionStorage.getItem("shaken:v2:user:option-edit-mode")) {
      this.isEditPrice = true;
      window.sessionStorage.removeItem("shaken:v2:user:option-edit-mode");
    }
    this.getOption();
  }

  mounted() {
    this.$emit("onActiveSideTab", "soukouhosho");
    this.menuReload();
  }

  getOption() {
    this.reqService = new requestService();

    if (!this.hasData && !this.isLoading) {
      const userService = new UserService();
      userService.getAllData();
      setTimeout(() => {
        this.onCheckChange();
      }, 750);
    } else {
      this.onCheckChange();
      this.menuReload();
    }
  }

  linkupOption(id: number) {
    let option: any = {
      "num": 9,
      "optionId": 256,
      "optionNm": "　登録代行料",
      "kingakuZn": 777,
      "kingakuZk": 777,
      "isCheck": 0,
      "renban": 0
    };

    if (this.optionData) {
      if (this.optionData.option && this.optionData.option.items) {
        let chache = this.optionData.option.items.filter((item: any) => item.optionId == id);
        if ( chache.length > 0 ) {
          option = chache[0];
        }
      }
    }
    return option;
  }


  onConfirm(isConfirm: number) {
    if (this.optionData) {
      if (this.optionData.option && this.optionData.option.items) {
        this.optionData.option.subTotalZk = this.subTotalZk;
        this.optionData.option.subTotalZn = this.subTotalZn;
      }
      this.setOption(this.optionData);
      let isConfirmCopied: any = isConfirm;
      if (isConfirm == 0) {
        isConfirmCopied = this.optionData.isConfirm;
      }
      if (this.optionDataForSave.option) {
        this.$set(this, "updating", true);
        const savePromise = this.reqService.saveOption({ // sendSocket:ソケット仮12
          options: this.optionDataForSave.option.items || []
          , sknUketsukeUserJouhou: { isConfirmOption: isConfirmCopied }
          , sknUketsukeExtendsId: this.uketsukeExtendsId
        }).then((res: any) => {
          this.$set(this, "updating", false);
          this.autoSave(0);
          if (isConfirm == 1) {
            /** 2021-07-09 sh #7131 it get option from server after save. [START] */
            // if (this.waitPartsSelect) {
            //   this.$refs.waitmd15Dialog.onOpen();
            // } else {
            //   this.$router.push({ name: "discountcoupon" });
            // }
            // 手動で追加したオプションにIDが保持されないので、保存した後、再読み込みをする。
            const userService = new UserService();
            let promise = userService.getOptionPM();
            Promise.all([promise]).then(() => {
              /** 2021-08-17 sh #7341 remove popup. [START] */
              // if (this.waitPartsSelect) {
              //  this.$refs.waitmd15Dialog.onOpen();
              //  } else {
              if ( this.isNextageCustom ) {
                this.$router.push({ name: "paymentdetail" });
              } else {
                this.$router.push({ name: "discountcoupon" });
              }
              // }
              /** 2021-08-17 sh #7341 remove popup. [END] */
            });
            /** 2021-07-09 sh #7131 it get option from server after save. [END] */
          }
          this.confirm(isConfirmCopied);
          this.$emit("onUserConfirm");
        }, (error: any) => {
          this.$set(this, "updating", false);
          this.$notify.error({
            title: "エラー",
            message: MESSAGE.SystemError
          });
        });
        // 保存処理中に赤画面の右サイドバーを無効化するため、親画面にPromiseを渡す
        this.$emit("onOptionCouponUpdating", savePromise);

      } else {
        this.autoSave(0);
        this.confirm(isConfirmCopied);
        this.$emit("onUserConfirm");
      }
    } else {
      this.autoSave(0);
      if (isConfirm == 1) {
        if ( this.isNextageCustom ) {
          this.$router.push({ name: "paymentdetail" });
        } else if (this.waitPartsSelect) {
          this.$refs.waitmd15Dialog.onOpen();
        } else {
          /** 2021-08-17 sh #7341 change path. [START] */
          // this.$router.push({ name: "userlegal56" });
          this.$router.push({ name: "discountcoupon" });
          /** 2021-08-17 sh #7341 change path. [END] */
        }
      }
    }
  }

  onSave() {
    this.onConfirm(0);
  }

  calcTotal() {
    let tempSubTotalZk: number = 0;
    let tempSubTotalZn: number = 0;
    if (this.optionData.option && this.optionData.option.items) {
      this.optionData.option.items.filter(data => {
        if (data.isCheck == 1) {
          tempSubTotalZk += data.kingakuZk ? data.kingakuZk : 0;
          tempSubTotalZn += data.kingakuZn ? data.kingakuZn : 0;
        }
      });
      this.subTotalZk = tempSubTotalZk;
      this.subTotalZn = tempSubTotalZn;
    }
  }

  onCheck(value: any, item: any) {
    item.isCheck = value ? 1 : 0;
  }

  gotoCustomer() {
    this.$router.push({
      name: "usercustomer",
      params: { code: this.yoyakuNo }
    });
  }

  onChangeOption() {
    /** 一度確認を押した後、内容が変更になったら、未にする */
    if (this.isConfirm == 1) {
      const optCurrent = JSON.stringify(this.optionDataForSave.option);
      const optOld = JSON.stringify(this.optionDataForSave.optionOld);
      if (optCurrent != optOld) {
        this.confirm(0);
        this.$emit("onUserConfirm");
      }
    }
    this.onCheckChange();
  }

  onChangeOptionRadio(option?: any) {
    // 選択した一つ以外はチェックを外す
    if ( this.optionData && this.optionData.option && this.optionData.option.items && option.warrantyKbn == 1) {
     // this.optionData.option.items.map((data: any) => ( data.isCheck = (data.optionId == option.optionId)?1:0));
      this.optionData.option.items.forEach((sub: any) => {
        // 保証用のオプションでチェックした項目以外を非表示に更新する
        if ( sub.warrantyKbn == 1 && sub.optionId != option.optionId ) {
          sub.isCheck = 0;
        }
      });
    }
    if ( this.optionData && this.optionData.option && this.optionData.option.items && option.warrantyKbn == 2) {
     // this.optionData.option.items.map((data: any) => ( data.isCheck = (data.optionId == option.optionId)?1:0));
      this.optionData.option.items.forEach((sub: any) => {
        // 保証用のオプションでチェックした項目以外を非表示に更新する
        if ( sub.warrantyKbn == 2 && sub.optionId != option.optionId ) {
          sub.isCheck = 0;
        }
      });
    }
    /** 一度確認を押した後、内容が変更になったら、未にする */
    if (this.isConfirm == 1) {
      const optCurrent = JSON.stringify(this.optionDataForSave.option);
      const optOld = JSON.stringify(this.optionDataForSave.optionOld);
      if (optCurrent != optOld) {
        this.confirm(0);
        this.$emit("onUserConfirm");
      }
    }
    this.onCheckChange();
  }

  onCheckChange(option?: any) {
    this.calcTotal();
    this.updateSubTotal({
      subTotalZk: this.subTotalZk,
      subTotalZn: this.subTotalZn
    });
  }

  focusNext(index: number) {
    if (this.$refs.inputKingaku[index + 1]) {
      this.$refs.inputKingaku[index + 1].focus();
    }
  }

  beforeDestroy() {
    if (this.isEditPrice) {
      window.sessionStorage.setItem("shaken:v2:user:option-edit-mode", "1");
    } else {
      window.sessionStorage.removeItem("shaken:v2:user:option-edit-mode");
    }
  }

  onOKWaitmd15Dialog() {
    this.$router.push({ name: "statusresult" });
  }

  onClickEdit(isEdit: boolean) {
    this.isEditPrice = isEdit;
    if (!this.isEditPrice) {
      this.onConfirm(0);
      this.onCheckChange(); // 小計金額更新
    }
  }

  addWork() {
    if (this.optionNm) {
      let item: OptionItem = {
        num: 0
        , optionNm: this.optionNm
        , kingakuZk: this.optionZk ? this.optionZk: 0
        /** 2023-10-19 invoice [START] */
        , kingakuZn: this.optionZn ? this.optionZn: 0
        /** 2023-10-19 invoice [END] */
        , isCheck: 0
      };
      if (this.optionData) {
        if (this.optionData.option) {
          if (this.optionData.option.items) {
            /** 2021-07-12 sh #7131 set max [START] */
            // item.num = this.optionData.option.items.length + 1;
            let serachItems: OptionItem[] = this.utils.deepCopy(this.optionData.option.items);
            let numMax: OptionItem = serachItems.reduce((prevItem: OptionItem, curItem: OptionItem) => { 
              return prevItem.num > curItem.num ? prevItem : curItem; }, item);
            item.num = numMax.num + 1;
            /** 2021-07-12 sh #7131 set max [END] */
            this.optionData.option.items.push(item);
          } else {
            let items = [];
            items.push(item);
            this.optionData.option.items = items;
          }
        } else {
            let items = [];
            items.push(item);
            let option = {
              items: items
            };
          this.optionData.option = option;
        }
      } else {
        let items = [];
        items.push(item);
        let option = {
          items: items
        };
        this.optionData = {
          option: option
        };
      }
      this.optionNm = "";
      this.optionZk = null;
      /** 2023-10-19 invoice [START] */
      this.optionZn = null;
      /** 2023-10-19 invoice [END] */
    }
    this.autoSave(1);
  }

  // 別画面移動時の自動保存を有効化
  setAutoSave() {
    this.autoSave(1);
  }
}
